let utils = require( './utils' );

let testimonials = ( function( $ ) {

	let	$testimonials;

	let _init = function() {
		$testimonials = $( '.testimonial-card' );

		if ( $testimonials.length > 1 && utils.viewport_size().width >= 992 ) {
			_match_heights();
		}
	};

	let _match_heights = function() {
		let height = 0;

		$testimonials.each( function( index, item ) {
			if ( $( item ).find( '.testimonial-content' ).outerHeight() > height ) {
				height = $( item ).find( '.testimonial-content' ).outerHeight();
			}
		} );

		$testimonials.find( '.testimonial-content' ).css( 'height', height );
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = testimonials;